/** Litany Lauretana structured verses (restored from master) */
export const litanyLauretanaMeta = {
  "id": "LL",
  "title": "Letanía de Loreto",
  "img": "/gallery-images/litany/01.JPG",
  "imgmo": "/gallery-images/misterios/modooscuro/francisco_de_asis_2.jpg",
  "text": "Señor, ten piedad: Señor, ten piedad\nCristo, ten piedad: Cristo, ten piedad\nSeñor, ten piedad: Señor, ten piedad\nCristo, óyenos: Cristo, óyenos\nCristo, escúchanos: Cristo, escúchanos\nDios Padre celestial: Ten piedad de nosotros\nDios Hijo, Redentor del mundo: Ten piedad de nosotros\nDios Espíritu Santo: Ten piedad de nosotros\nSantísima Trinidad, un solo Dios: Ten piedad de nosotros\nSanta María: Ruega por nosotros\nSanta Madre de Dios: Ruega por nosotros\nSanta Virgen de las vírgenes: Ruega por nosotros\nMadre de Cristo: Ruega por nosotros\nMadre de la divina gracia: Ruega por nosotros\nMadre purísima: Ruega por nosotros\nMadre castísima: Ruega por nosotros\nMadre siempre virgen: Ruega por nosotros\nMadre inmaculada: Ruega por nosotros\nMadre sin mancilla: Ruega por nosotros\nMadre amable: Ruega por nosotros\nMadre admirable: Ruega por nosotros\nMadre del buen consejo: Ruega por nosotros\nMadre del Creador: Ruega por nosotros\nMadre del Salvador: Ruega por nosotros\nVirgen prudentísima: Ruega por nosotros\nVirgen venerable: Ruega por nosotros\nVirgen digna de alabanza: Ruega por nosotros\nVirgen poderosa: Ruega por nosotros\nVirgen clemente: Ruega por nosotros\nVirgen fiel: Ruega por nosotros\nEspejo de justicia: Ruega por nosotros\nTrono de la sabiduría: Ruega por nosotros\nCausa de nuestra alegría: Ruega por nosotros\nVaso espiritual: Ruega por nosotros\nVaso digno de honor: Ruega por nosotros\nVaso insigne de devoción: Ruega por nosotros\nRosa mística: Ruega por nosotros\nTorre de David: Ruega por nosotros\nTorre de marfil: Ruega por nosotros\nCasa de oro: Ruega por nosotros\nArca de la alianza: Ruega por nosotros\nPuerta del cielo: Ruega por nosotros\nEstrella de la mañana: Ruega por nosotros\nSalud de los enfermos: Ruega por nosotros\nRefugio de los pecadores: Ruega por nosotros\nConsoladora de los afligidos: Ruega por nosotros\nAuxilio de los cristianos: Ruega por nosotros\nReina de los Ángeles: Ruega por nosotros\nReina de los Patriarcas: Ruega por nosotros\nReina de los Profetas: Ruega por nosotros\nReina de los Apóstoles: Ruega por nosotros\nReina de los Mártires: Ruega por nosotros\nReina de los Confesores: Ruega por nosotros\nReina de las Vírgenes: Ruega por nosotros\nReina de todos los Santos: Ruega por nosotros\nReina concebida sin pecado original: Ruega por nosotros\nReina asunta a los cielos: Ruega por nosotros\nReina del Santísimo Rosario: Ruega por nosotros\nReina de la familia: Ruega por nosotros\nReina de la paz: Ruega por nosotros\nCordero de Dios, que quitas el pecado del mundo: Perdónanos, Señor\nCordero de Dios, que quitas el pecado del mundo: Escúchanos, Señor\nCordero de Dios, que quitas el pecado del mundo: Ten piedad de nosotros\nRuega por nosotros, Santa Madre de Dios: Para que seamos dignos de las promesas de Nuestro Señor Jesucristo\n\nOremos: Te rogamos nos concedas, Señor Dios nuestro, gozar de continua salud de alma y cuerpo, y por la gloriosa intercesión de la bienaventurada siempre Virgen María, vernos libres de las tristezas presentes y disfrutar de las alegrías eternas. Por Cristo nuestro Señor. Amén."
};

export const litanyLauretanaSections = [
  {
    "name": "Invocaciones",
    "start": 0,
    "end": 8,
    "total": 9
  },
  {
    "name": "Títulos marianos",
    "start": 9,
    "end": 59,
    "total": 51
  },
  {
    "name": "Cierre",
    "start": 60,
    "end": 64,
    "total": 5
  }
];

export const litanyLauretanaVerses = [
  {
    "invocation": "Señor, ten piedad",
    "invocationLatin": "Kyrie eleison",
    "response": "Señor, ten piedad",
    "responseLatin": "Kyrie eleison",
    "section": 1,
    "img": "/gallery-images/litany/01-0-0.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/kyrie-eleison.jpg"
  },
  {
    "invocation": "Cristo, ten piedad",
    "invocationLatin": "Christe eleison",
    "response": "Cristo, ten piedad",
    "responseLatin": "Christe eleison",
    "section": 1,
    "img": "/gallery-images/litany/01-0-1.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/christe-eleison Christ as King and Ruler _ File_Toomyvara St_ Joseph's Church Window Tu Rex Gloriae Christe by.jpg"
  },
  {
    "invocation": "Señor, ten piedad",
    "invocationLatin": "Kyrie eleison",
    "response": "Señor, ten piedad",
    "responseLatin": "Kyrie eleison",
    "section": 1,
    "img": "/gallery-images/litany/01-0-2.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/kyrie-eleison2.jpg"
  },
  {
    "invocation": "Cristo, óyenos",
    "invocationLatin": "Christe audi nos",
    "response": "Cristo, óyenos",
    "responseLatin": "Christe audi nos",
    "section": 1,
    "img": "/gallery-images/litany/01-0-3.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/cristo-oyenos_This mystery is that through the gospel the….jpg"
  },
  {
    "invocation": "Cristo, escúchanos",
    "invocationLatin": "Christe exaudi nos",
    "response": "Cristo, escúchanos",
    "responseLatin": "Christe exaudi nos",
    "section": 1,
    "img": "/gallery-images/litany/modooscuro/cristo-escuchanos.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/cristo-escuchanos.jpg"
  },
  {
    "invocation": "Dios Padre celestial",
    "invocationLatin": "Deus Pater caelestis",
    "response": "Ten piedad de nosotros",
    "responseLatin": "Miserere nobis",
    "section": 1,
    "img": "/gallery-images/litany/01-1-1.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Padre-celestial The Litany of God the Father.jpg"
  },
  {
    "invocation": "Dios Hijo, Redentor del mundo",
    "invocationLatin": "Deus Filius, Redemptor mundi",
    "response": "Ten piedad de nosotros",
    "responseLatin": "Miserere nobis",
    "section": 1,
    "img": "/gallery-images/litany/01-1-2.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/hijo-redentor.jpg"
  },
  {
    "invocation": "Dios Espíritu Santo",
    "invocationLatin": "Deus Spiritus Sanctus",
    "response": "Ten piedad de nosotros",
    "responseLatin": "Miserere nobis",
    "section": 1,
    "img": "/gallery-images/litany/01-1-3.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/espiritu santo.jpg"
  },
  {
    "invocation": "Santísima Trinidad, un solo Dios",
    "invocationLatin": "Sancta Trinitas, unus Deus",
    "response": "Ten piedad de nosotros",
    "responseLatin": "Miserere nobis",
    "section": 1,
    "img": "/gallery-images/litany/modooscuro/santisima-trinidad.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/santisima-trinidad.jpg"
  },
  {
    "invocation": "Santa María",
    "invocationLatin": "Sancta Maria",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-0-0.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/sancta-maria-ora-pro-nobis.jpg"
  },
  {
    "invocation": "Santa Madre de Dios",
    "invocationLatin": "Sancta Dei Genetrix",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-0-1.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/madre-de-dios-ora-pro-nobis.jpg"
  },
  {
    "invocation": "Santa Virgen de las vírgenes",
    "invocationLatin": "Sancta Virgo virginum",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-0-2.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/virgo-virginum.jpg"
  },
  {
    "invocation": "Madre de Cristo",
    "invocationLatin": "Mater Christi",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-0-3.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/mater-cristi.jpg"
  },
  {
    "invocation": "Madre de la divina gracia",
    "invocationLatin": "Mater divinae gratiae",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-1-1.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/mater-divina-gratiae.jpg"
  },
  {
    "invocation": "Madre purísima",
    "invocationLatin": "Mater purissima",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-1-1.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/mater-purissima.jpg"
  },
  {
    "invocation": "Madre castísima",
    "invocationLatin": "Mater castissima",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-1-2.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/mater-castissima.jpg"
  },
  {
    "invocation": "Madre siempre virgen",
    "invocationLatin": "Mater semper virgo",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-1-3.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Mater semper virgo.jpg"
  },
  {
    "invocation": "Madre inmaculada",
    "invocationLatin": "Mater immaculata",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-2-1.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Mater immaculata.jpg"
  },
  {
    "invocation": "Madre sin mancilla",
    "invocationLatin": "Mater sine macula",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-2-1.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Mater sine macula.jpg"
  },
  {
    "invocation": "Madre amable",
    "invocationLatin": "Mater amabilis",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-2-2.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Mater amabilis.jpg"
  },
  {
    "invocation": "Madre admirable",
    "invocationLatin": "Mater admirabilis",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-2-3.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/mater-admirabilis.jpg"
  },
  {
    "invocation": "Madre del buen consejo",
    "invocationLatin": "Mater boni consilii",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-3-0.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Mater boni consilii.jpg"
  },
  {
    "invocation": "Madre del Creador",
    "invocationLatin": "Mater Creatoris",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-3-1.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Mater Creatoris.jpg"
  },
  {
    "invocation": "Madre del Salvador",
    "invocationLatin": "Mater Salvatoris",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-3-2.JPG",
    "imgmo": "/gallery-images/litany/01-3-2.JPG"
  },
  {
    "invocation": "Virgen prudentísima",
    "invocationLatin": "Virgo prudentissima",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-3-3.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Virgo prudentissima.jpg"
  },
  {
    "invocation": "Virgen venerable",
    "invocationLatin": "Virgo veneranda",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-4-0.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Virgo veneranda.jpg"
  },
  {
    "invocation": "Virgen digna de alabanza",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/01-4-1.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/digna-de-alabanza.jpg"
  },
  {
    "invocation": "Virgen poderosa",
    "invocationLatin": "Virgo potens",
    "responseLatin": "Ora pro nobis",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/01-4-2.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Virgen poderosa.jpg"
  },
  {
    "invocation": "Virgen clemente",
    "invocationLatin": "Virgo clemens",
    "responseLatin": "Ora pro nobis",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/01-4-3.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Virgen clemente.jpg"
  },
  {
    "invocation": "Virgen fiel",
    "invocationLatin": "Virgo fidelis",
    "responseLatin": "Ora pro nobis",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/01-5-0.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Virgen fiel.jpg"
  },
  {
    "invocation": "Espejo de justicia",
    "invocationLatin": "Speculum iustitiae",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-5-1.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Speculum iustitiae.jpg"
  },
  {
    "invocation": "Trono de la sabiduría",
    "invocationLatin": "Sedes sapientiae",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-5-2.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/trono-sabiduria.jpg"
  },
  {
    "invocation": "Causa de nuestra alegría",
    "invocationLatin": "Causa nostrae laetitiae",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-5-3.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Causa nostrae laetitiae.jpg"
  },
  {
    "invocation": "Vaso espiritual",
    "invocationLatin": "Vas spirituale",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-6-0.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Vas spirituale2.jpg"
  },
  {
    "invocation": "Vaso digno de honor",
    "invocationLatin": "Vas honorabile",
    "responseLatin": "Ora pro nobis",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/01-6-1.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Vas honorabile.jpg"
  },
  {
    "invocation": "Vaso insigne de devoción",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/01-6-2.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/Stained glass of St_ Michael the Archangel.jpg"
  },
  {
    "invocation": "Rosa mística",
    "invocationLatin": "Rosa mystica",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/01-6-3.JPG",
    "imgmo": "/gallery-images/litany/modooscuro/St_ Margaret of Scotland.jpg"
  },
  {
    "invocation": "Torre de David",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/Life Is Short And So Am I_ Photo.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/torre-de-david.jpg"
  },
  {
    "invocation": "Torre de marfil",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/torre-marfil.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/Hedwig in Danbury, CT.jpg"
  },
  {
    "invocation": "Casa de oro",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/Casa de oro.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/Casa de oro.jpg"
  },
  {
    "invocation": "Arca de la alianza",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/Arca de la alianza.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/Arca de la alianza.jpg"
  },
  {
    "invocation": "Puerta del cielo",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/Puerta del cielo.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/Puerta del cielo.jpg"
  },
  {
    "invocation": "Estrella de la mañana",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/estrella-manana.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/estrella-manana.jpg"
  },
  {
    "invocation": "Salud de los enfermos",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/lourdes.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/lourdes.jpg"
  },
  {
    "invocation": "Refugio de los pecadores",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/Refugio de los pecadores.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/Refugio de los pecadores.jpg"
  },
  {
    "invocation": "Consoladora de los afligidos",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/Consoladora de los afligidos.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/Consoladora de los afligidos.jpg"
  },
  {
    "invocation": "Auxilio de los cristianos",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/Saint Casimir of Poland (1483).jpg",
    "imgmo": "/gallery-images/litany/modooscuro/Saint Casimir of Poland (1483).jpg"
  },
  {
    "invocation": "Reina de los Ángeles",
    "invocationLatin": "Regina Angelorum",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/reina-de-los-angeles.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/reina-de-los-angeles.jpg"
  },
  {
    "invocation": "Reina de los Patriarcas",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/Reina de los Patriarcas.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/Reina de los Patriarcas.jpg"
  },
  {
    "invocation": "Reina de los Profetas",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/Beautiful scenes of the Polish chapel in Stamford, CT.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/Beautiful scenes of the Polish chapel in Stamford, CT.jpg"
  },
  {
    "invocation": "Reina de los Apóstoles",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/reina-apostoles.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/Reina de los Apóstoles.jpg"
  },
  {
    "invocation": "Reina de los Mártires",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/reina-martires.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/reina-martires.jpg"
  },
  {
    "invocation": "Reina de los Confesores",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/reina-confesores.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/reina-confesores.jpg"
  },
  {
    "invocation": "Reina de las Vírgenes",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/St_ Mary's Roman Catholic Church, Albany, New York.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/St_ Mary's Roman Catholic Church, Albany, New York.jpg"
  },
  {
    "invocation": "Reina de todos los Santos",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/modooscuro/reina-santos.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/reina-de-todos.jpg"
  },
  {
    "invocation": "Reina concebida sin pecado original",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/lll_1-1-7.png",
    "imgmo": "/gallery-images/litany/modooscuro/reina-concebida.jpg"
  },
  {
    "invocation": "Reina asunta a los cielos",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/lll_1-2-7.png",
    "imgmo": "/gallery-images/litany/lll_1-2-7.png"
  },
  {
    "invocation": "Reina del Santísimo Rosario",
    "invocationLatin": "Regina Sacratissimi Rosarii",
    "response": "Ruega por nosotros",
    "responseLatin": "Ora pro nobis",
    "section": 2,
    "img": "/gallery-images/litany/lll_1-3-7.png",
    "imgmo": "/gallery-images/litany/modooscuro/virgen-rosario.jpg"
  },
  {
    "invocation": "Reina de la familia",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/lll_1-4-7.png",
    "imgmo": "/gallery-images/litany/modooscuro/reina.jpg"
  },
  {
    "invocation": "Reina de la paz",
    "response": "Ruega por nosotros",
    "section": 2,
    "img": "/gallery-images/litany/loreto0.jpg",
    "imgmo": "/gallery-images/litany/modooscuro/SANTA MARGARITA MARÍA DE ALACOQUE FRENTE AL SAGRADO CORAZÓN DE JESÚS !!!.jpg"
  },
  {
    "invocation": "Cordero de Dios, que quitas el pecado del mundo",
    "invocationLatin": "Agnus Dei, qui tollis peccata mundi",
    "response": "Perdónanos, Señor",
    "responseLatin": "Miserere nobis",
    "imgmo": "/gallery-images/litany/modooscuro/cordero.jpg",
    "section": 3
  },
  {
    "invocation": "Cordero de Dios, que quitas el pecado del mundo",
    "invocationLatin": "Agnus Dei, qui tollis peccata mundi",
    "response": "Escúchanos, Señor",
    "responseLatin": "Exaudi nos Domine",
    "imgmo": "/gallery-images/litany/modooscuro/agnus-dei.jpg",
    "section": 3
  },
  {
    "invocation": "Cordero de Dios, que quitas el pecado del mundo",
    "invocationLatin": "Agnus Dei, qui tollis peccata mundi",
    "response": "Ten piedad de nosotros",
    "responseLatin": "Miserere nobis",
    "imgmo": "/gallery-images/litany/modooscuro/agnus-dei-miserere-nobis.jpg",
    "section": 3
  },
  {
    "invocation": "Ruega por nosotros, Santa Madre de Dios",
    "invocationLatin": "Ora pro nobis, Sancta Dei Genetrix",
    "response": "Para que seamos dignos de las promesas de Nuestro Señor Jesucristo",
    "responseLatin": "Ut digni efficiamur promissionibus Christi",
    "imgmo": "/gallery-images/litany/modooscuro/Sancta Dei Genetrix.jpg",
    "section": 3
  },
  {
    "invocation": "Oremos",
    "invocationLatin": "Oremus",
    "imgmo": "/gallery-images/litany/modooscuro/Um vitral iluminado em uma catedral gótica, o sol lançando uma luz colorida etérea nos bancos abaixo_ Papel de parede [4e77f3a2d38b4e3d91d3] por Wallpaper HD _ WidgetC.jpg",
    "response": "Te rogamos nos concedas, Señor Dios nuestro, gozar de continua salud de alma y cuerpo, y por la gloriosa intercesión de la bienaventurada siempre Virgen María, vernos libres de las tristezas presentes y disfrutar de las alegrías eternas. Por Cristo nuestro Señor. Amén.",
    "responseLatin": "Concede nos famulos tuos, quaesumus, Domine Deus, perpetua mentis et corporis sanitate gaudere: et gloriosa beatae Mariae semper Virginis intercessione, a praesentibus liberari tristitiis, et aeterna perfrui laetitia. Per Christum Dominum nostrum. Amen.",
    "section": 3
  }
];
